import React from "react";

const OfferCard = ({
  title,
  description,
  imageUrl,
  className,
  borderOnHover = false,
}) => {
  return (
    <>
      <div
        className={`group rounded-2xl overflow-hidden text-white relative w-full shadow-lg ${className} h-[588px] ${
          borderOnHover
            ? "border-2 border-transparent hover:border-zinc-500"
            : ""
        }   transition-all ease-linear duration-300`}
      >
        <div className="flex flex-col items-start px-6 pt-8 pb-4 bg-[#252525] rounded-t-xl relative z-10">
          <h2 className="text-lg md:text-xl font-bold font-theBrittanySans">
            {title}
          </h2>
          <p className="text-sm md:text-base mt-2">{description}</p>
        </div>
        <div className="h-20 bg-gradient-to-b from-[#252525] from-10%  to-transparent to-100% z-10"></div>

        <div className="absolute top-20 left-0 w-full h-full overflow-hidden -z-10">
          <img
            src={imageUrl}
            alt="AI Strategy"
            className="w-full h-full object-center object-cover absolute top-0 left-0 transition-all ease-linear duration-300 group-hover:scale-[101%] grayscale"
          />
        </div>
      </div>
    </>
  );
};

export default OfferCard;
